'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'bug';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f188';
var svgPathData = 'M368 96c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 16 160 0 0-16zM192 96c0-53 43-96 96-96s96 43 96 96l0 32-192 0 0-32zM432 352l0-160-288 0 0 160c0 76.8 60.2 139.6 136 143.8l0-239.8 16 0 0 239.8c75.8-4.2 136-66.9 136-143.8zM128 180l-92.8-69.6-6.4-4.8 9.6-12.8 6.4 4.8 104.5 78.4 277.3 0 104.5-78.4 6.4-4.8 9.6 12.8-6.4 4.8-92.8 69.6 0 100 128 0 0 16-128 0 0 56c0 13.9-1.8 27.3-5.1 40.2l1.9 1.4 96 72 6.4 4.8-9.6 12.8-6.4-4.8-93.4-70.1C415 468.9 356.5 512 288 512S161 468.9 138.2 408.3l-93.4 70.1-6.4 4.8-9.6-12.8 6.4-4.8 96-72 1.9-1.4c-3.3-12.8-5.1-26.3-5.1-40.2l0-56-128 0 0-16 128 0 0-100z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;